import slider001 from "../styles/pdfs/диплом МИФИ.png";
import slider002 from "../styles/pdfs/Диплом JS Нетология_Страница_1.png";
import slider003 from "../styles/pdfs/Диплом РЭУ Плеханова.png";
import slider004 from "../styles/pdfs/certificate GIT Netology.png";
import slider005 from "../styles/pdfs/certificate JS-cp-2 Netology.png";
import slider006 from "../styles/pdfs/certificate React.js Netology 2.png";
import slider007 from "../styles/pdfs/certificate React.js Netology.png";
import slider008 from "../styles/pdfs/Диплом JS Нетология_Страница_2.png";


const certs = [
  {
    title: "Диплом МИФИ",
    img: slider001,
    skills: "",
    link: "",
  },
  {
    title: "certificate React.js Netology 2",
    img: slider006,
    skills: "",
    link: "",
  },
  {
    title: "certificate React.js Netology",
    img: slider007,
    skills: "",
    link: "",
  },
  {
    title: "certificate JS-cp-2 Netology",
    img: slider005,
    skills: "",
    link: "",
  },
  {
    title: "certificate GIT Netology",
    img: slider004,
    skills: "",
    link: "",
  },
  {
    title: "Диплом JS Нетология (страница 1)",
    img: slider002,
    skills: "",
    link: "",
  },
  {
    title: "Диплом JS Нетология (страница 2)",
    img: slider008,
    skills: "",
    link: "",
  },
  {
    title: "Диплом РЭУ Плеханова",
    img: slider003,
    skills: "",
    link: "",
  },
];

export { certs };
